<template>
  <div
    :style="{
      height: `${pagesHeight}px`,
      overflow: 'hidden'
    }"
  >
    <div
      class="page-config"
      :style="{
        'background': pageConfig.backgroundColor || '#0b0b1e',
        'width': pageConfig.width ? `${pageConfig.width}px` : '100vw',
        'height': pageConfig.height ? `${pageConfig.height}px` : '100vh',
        'position': 'relative',
        'transformOrigin':'left top',
        'transform':`scale(${scalseNum})`,
        '-webkit-transform':`scale(${scalseNum})`,
        '-moz-transform':`scale(${scalseNum})`,
        '-o-transform':`scale(${scalseNum})`,
        '-ms-transform':`scale(${scalseNum})`
      }"
    >
      <template v-if="!showSelect">
        <div
          class="guides-header"
          v-if="pageConfig.headerShow"
          :style="{background: pageConfig.headBackgroundColor}"
        >
          <div
            class="header-left"
          >
            <div class="site-name">{{ pageConfig.title }}</div>
            <template v-if="pageConfig.timeShow">
              <span
                class="select-mounth coocaa_btn select-mounth-my"
                id="select-mounth"
                rel="select-mounth"
                @click="selectMonth"
                v-focusable
              >选择月份：{{ yearMonth }}<i class="el-icon-d-caret"></i></span>
              <span class="cur-time">数据统计时间至：{{ cutOffDate }}</span>
            </template>
          </div>
          <div class="header-right">
            <div
              class="return-page coocaa_btn"
              v-if="pageConfig.returnShow"
              id="return-btn"
              rel="return-btn"
              @click="toReturn"
              v-focusable
            >
              返回 <span class="el-icon-arrow-right"></span>
            </div>
          </div>
        </div>
        <template v-if="isShow">
          <div
            :style="{
              position: 'absolute',
              width: `${item.outerFrameStyle.width}px`,
              height: `${item.outerFrameStyle.height}px`,
              left: `${item.outerFrameStyle.left}px`,
              top: `${item.outerFrameStyle.top}px`
            }"
            v-for="(item, index) in kanbanDataList"
            :key="index"
          >
            <chart-line
              version="v3"
              :key="item.viewId"
              :id="item.viewId"
              :chart-data="item.data"
              :config="item.config"
              :spare-data="item.spareData"
              @openSelect="openSelect"
            >
            </chart-line>
          </div>
        </template>
        <div class="error-box" v-else>
          <div class="icon"><span class="el-icon-close"></span></div>
          <div class="text">{{ errorText }}</div>
        </div>
      </template>

      <!--下拉选择器弹出层-->
      <select-chart
        v-if="showSelect"
        :select-data="showSelectData"
        @closeSelect="closeSelect"
      ></select-chart>
    </div>
    <p id="hidd"></p>
  </div>
</template>

<script>
import ccMapMixin from '@/mixins/ccmap'
import chartLine from '@/components/chart/line.vue'
import { setAttrFnCb, setSpareData } from '@/components/common'
import selectChart from '@/components/chart/SelectChart'
import { checkG2ChartOpionHandler } from '@/utils/separatetools.js'
export default {
  mixins: [ccMapMixin],
  components: {
    chartLine,
    selectChart
  },
  props: {
    kanbanConfig: {
      type: [Object],
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      routerPathLists: [
        {
          value: '酷开主页',
          label: '酷开主页'
        },
        {
          value: '大内容事业部',
          label: '大内容事业部'
        },
        {
          value: '数字营销事业部',
          label: '数字营销事业部'
        },
        {
          value: '系统拓展事业部',
          label: '系统拓展事业部'
        },
        {
          value: 'Coolita事业部',
          label: 'Coolita事业部'
        },
        {
          value: '财务经营业绩',
          label: '财务经营业绩'
        }
      ],
      showSelectData: {},
      showSelect: false,
      errorText: '',
      isShow: true,
      cutOffDate: '',
      scalseNum: 1,
      pagesHeight: 1080,
      kanbanDataList: [],
      pageConfig: {
        style: []
      },
      loading: false
    }
  },
  watch: {
    $route (news) {
      if (['kanbanConfigView', 'kanban-config-view'].includes(news.name)) {
        this.kanbanDataList = []
        this.getboardData()
      }
    }
  },
  computed: {
    yearMonth () {
      return JSON.parse(sessionStorage.getItem('toggleDate')).time
    },
    month () {
      const date = new Date()
      return date.getMonth() + 1
    },
    selectVal () {
      return this.$store.state.app.selectVal
    }
  },
  mounted () {
    // this.resize_window()
    window.addEventListener('resize', () => {
      this.resize_window()
    })
    this.$bus.$on('searchSelect', this.activatedFn)
    if (this.$route.query.id === '65' && this.$route.query.from) {
      console.log(this.$route)
      let item = this.routerPathLists.find(i => i.label === this.$route.query.from)
      if (item) {
        console.log(item)
        this.$store.dispatch('searchKanBanData', {
          key: '{name}',
          value: item.value,
          label: item.label,
          mapValue: 'value',
          mapLabel: 'label'
        }).then(() => {
          this.closeSelect(true)
        })
      }
    } else {
      this.activatedFn()
    }
    if (['kanbanConfigView', 'kanban-config-view'].includes(this.$route.path)) {
      console.log(this.$route.path)
      this.kanbanDataList = []
      this.getboardData()
    }
  },
  methods: {
    selectMonth () {
      localStorage.setItem('returnPage', location.pathname + location.search)
      location.href = '/select-month'
    },
    openSelect (data) {
      this.showSelectData = data
      this.showSelect = true
    },
    closeSelect (flag) {
      this.showSelect = false
      if (flag) {
        this.activatedFn()
        // this.$bus.$emit('searchSelect')
      }
    },
    toReturn () {
      // const returnPage = localStorage.getItem('returnPage')
      // window.location = returnPage || '/'
      // localStorage.removeItem('returnPage')
      window.top.history.go(-1)
      // const routeInfo = this.$store.state.app.routeInfo
      // if (routeInfo.name) {
      //   this.$router.go(-1)
      // } else {
      //   this.$router.push({
      //     name: 'index',
      //     query: {}
      //   })
      // }
    },
    bindKey () {
    },
    evil (fn) {
      if (this.isJSON(fn)) {
        return JSON.parse(fn)
      } else {
        const Fn = Function
			  return new Fn('return ' + fn)()
      }
    },
    isJSON (str) {
      if (typeof str === 'string') {
        try {
          var obj = JSON.parse(str)
          if (typeof obj === 'object' && obj) {
            return true
          } else {
            return false
          }
        } catch (e) {
          return false
        }
      } else if (typeof str === 'object' && str) {
        return true
      }
    },
    resize_window () {
      const scalseNum = Number(document.documentElement.clientWidth / this.pageConfig.width || 1920)
      this.scalseNum = scalseNum > 1 ? 1 : scalseNum
      this.pagesHeight = (this.pageConfig.height || 1080) * scalseNum
    },
    setCutOffDate () {
      const selectMonth = parseInt(JSON.parse(sessionStorage.getItem('toggleDate')).time.substr(5))
      if (this.month === selectMonth) {
        this.cutOffDate = this.$cUtils.format.formatDate(new Date((new Date()).getTime() - 86400000), 'yyyy-MM-dd')
      } else {
        this.cutOffDate = this.$cUtils.format.formatDate(new Date(2021, selectMonth, 0), 'yyyy-MM-dd')
      }
    },
    arrayToPx (array) {
      return array.map(item => {
        return `${item}px`
      }).join(' ')
    },
    async getboardData () {
      const boardId = this.$route.query.id
      this.isShow = true
      let tempRes = JSON.parse(JSON.stringify(this?.kanbanConfig?.style ?? {}))
      const pageConfig = JSON.parse(JSON.stringify(this.kanbanConfig))
      this.$delete(pageConfig, 'style')
      tempRes = this.initStyleOp(tempRes)
      this.pageConfig = pageConfig
      this.resize_window()
      // 获取数据
      // 去掉数据中label
      const queryListKey = []
      const queryList = this.selectVal.map(item => {
        queryListKey.push(item.type)
        return {
          type: item.type,
          values: item.values
        }
      })
      if (pageConfig.timeShow) {
        queryList.push({
          type: 'month',
          values: this.yearMonth
        })
      }

      tempRes.filter(item => {
        return item.config.chartType === 'select'
      }).forEach(item => {
        const DBAKey = item.config.DBAKey
        if (!queryListKey.includes(DBAKey)) {
          queryList.push({
            type: DBAKey,
            values: ''
          })
        }
      })

      let dataRes = await this.$service.fetch({
        method: 'POST',
        url: `api/item/pre/data`,
        data: {
          itemId: parseInt(boardId),
          queryList
        },
        useLoading: false
      })
      this.kanbanDataList = tempRes.map(item => {
        if (item.dataConfig.dataType !== 'none') {
          const data = dataRes[item.viewId]
          const dataSource = data?.dataSource ?? []
          // 如果是电子表格 拿到tBody即可
          let tempData
          if (dataSource === 2 || dataSource === 0) {
            tempData = this.evil(data.data)['tBody'] ? this.evil(data.data)['tBody'] : this.evil(data.data)
          } else {
            tempData = data?.data
          }
          this.$set(item, 'data', tempData)
          this.$set(item, 'spareData', setSpareData(item))
          // 针对图表函数不能JSON化特别处理
          item = setAttrFnCb(item)
        }
        return item
        // return group
      })
      setTimeout(() => {
        this.loading.close()
        this.$nextTick(() => {
          this.bindKey()
        })
      }, 500)
    },
    seeDetails (link) {
      if (window.event.keyCode) return false
      if (link.includes('http://') || link.includes('https://')) {
        window.location.href = link
      } else {
        this.$router.push({
          path: link
        })
      }
    },
    activatedFn () {
      this.kanbanDataList = []
      this.getboardData()
      this.setCutOffDate()
      this.loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 1)'
      })
    },
    initStyleOp (val) {
      let v = val.map(item => {
        if (item.config.chartType === 'pie') {
          if (item?.config?.label?.contentKey === '' || item?.config?.label?.contentKey) {
            item.config.label.content = (res) => {
              return item.config.label.contentKey.replace(/{([a-zA-Z]+)}|(\\n|\n)/g, ($1, $2, $3) => {
                if ($2) { return res[$2] }
                if ($3) { return '\r\n' }
                return ''
              })
            }
          }
          if (item?.config?.statistic) {
            checkG2ChartOpionHandler({ config: item.config })
          }
        }
        if (item.config.chartType === 'funnel') {
          if (item?.config?.conversionTag) {
            checkG2ChartOpionHandler({ config: item.config })
          }
          if (item?.config?.padding && item?.config?.padding === 'auto') {
            item.config.padding = [0, 0, 0, 0]
          }
        }
        return item
      })

      return v
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import './stylus/KanbanConfigView.styl'
  .error-box
    width 100%
    color #fff
    position fixed
    left 0
    text-align center
    top 50%
    margin-top -75px
    .icon
      width 100px
      height 100px
      line-height 100px
      font-size 70px
      margin 0 auto
      opacity .3
      border-radius 100%
      color #000
      background #fff
      // border 5px solid #fff
    .text
      height 50px
      line-height 50px
      padding-top 10px
      opacity .4
      font-size 25px
#hidd
  display none

.page-config .guides-header .header-left .select-mounth-my
  margin-top: 0
.header-left
  display flex
  align-items center
#return-btn
  display flex
  align-items center
</style>
